import "./App.css";
import NavbarUI from "./components/shared/navbarUi";
import "bootstrap/dist/css/bootstrap.min.css";
import EntityCardReact from "./components/entities/entityCardReact";
import React, { useEffect, useState , useContext} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import { NavLink, useParams, useLocation } from "react-router-dom";
import { LanguageContext, translateText } from "./components/shared/language";

function useQuery() {
  const output = [];
  const result = new URLSearchParams(useLocation().search);
  for (var [key, value] of result.entries()) {
    output.push({ key, value });
  }
  return output;
}

function App({ entities }) {
  const searchPositionEntityById = (id, entitiesArray) => {
    const result = entitiesArray.map((entity) => entity.id).indexOf(id);
    return result;
  };
  const {  userLanguage } = useContext(LanguageContext);
  let query = useQuery();
  const [apps] = useState(entities.map((entity) => entity.app));
  const { appUrl = entities[0].app } = useParams();
  const [entitiesApp, setEntititesApp] = useState(
    entities.filter((entity) => entity.app === appUrl)
  );

  const { idUrl = entities.find((entity) => entity.app === appUrl && entity.order === 1).id } =
    useParams();
  const [posEntityUrl, setPosEntityUrl] = useState(
    searchPositionEntityById(
      idUrl,
      entities.filter((entity) => entity.app === appUrl)
    )
  );

  const getQueryGroups = () => {
    let result = entitiesApp.map((entity) => ({
      group: entity.group,
      group_order: entity.group_order,
    }));
    result = result.filter(
      (s1, pos, arr) => arr.findIndex((s2) => (s2.group.es || s2.group ) === (s1.group.es || s1.group )) === pos
    );
    return result;
  };

  function compareQueryOrder(a, b) {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  }

  function filterEntitiesByGroup(group, index) {
    return entitiesApp
      .filter((entity) => (entity.group.es || entity.group) === (group.group.es || group.group))
      .sort(compareQueryOrder)
      .map((entity) => {
        return (
          <Accordion.Collapse
            eventKey={index.toString()}
            key={entity.id + index}
          >
            <ListGroup as="div" key={(entity.group.es || entity.group)  + index}>
              <NavLink
                to={`/${appUrl}/${entity.id}`}
                className={entity.id === idUrl ? "activa" : ""}
              >
                <ListGroup.Item
                  as="div"
                  style={{ textAlign: "left", width: "100%" }}
                  className="entity_item"
                >
                {translateText(entity.title, userLanguage)}
                   </ListGroup.Item>
              </NavLink>
            </ListGroup>
          </Accordion.Collapse>
        );
      });
  }

  useEffect(() => {
    const newEntities = entities.filter((entity) => entity.app === appUrl);
    setEntititesApp(newEntities);
    setPosEntityUrl(searchPositionEntityById(idUrl, newEntities));
  }, [appUrl, idUrl, entities]);

  return (
      <Container fluid>
        <Row>
          <Col className="columna__navbar">
            <NavbarUI apps={apps} />
          </Col>
        </Row>
        <Row>
          <Col xs={2} style={{ paddingLeft: "2rem" }}>
            <Accordion defaultActiveKey="0">
              {getQueryGroups()
                .sort((entityA, entityB) =>
                  entityA.group_order > entityB.group_order ? 1 : -1
                )
                .map((group, index) => {
                  return (
                    <Card key={(group.group.es || group.group) + index} style={{ border: "none" }}>
                      <div className="cabecera-sidenav">
                        <Accordion.Toggle as="div" eventKey={index.toString()}>
                          {translateText(group.group, userLanguage)}
                        </Accordion.Toggle>
                      </div>
                      {filterEntitiesByGroup(group, index)}
                    </Card>
                  );
                })}
            </Accordion>
          </Col>
           <Col xs={10}>
            <EntityCardReact
              id={entitiesApp[posEntityUrl].id}
              title={entitiesApp[posEntityUrl].title}
              description={entitiesApp[posEntityUrl].description}
              entity_parameters={entitiesApp[posEntityUrl].parameters.map(
                (parameter) => ({ ...parameter, value: "" })
              )}
              version={entitiesApp[posEntityUrl].version}
              queries={entitiesApp[posEntityUrl].querys}
              estimateDurationProps={
                entitiesApp[posEntityUrl].estimate_duration
              }
              queryParams={query}
            />
          </Col>
        </Row>
      </Container>
  );
}

export default App;
